import theme from '@dbk/ui-theme';

export const SEPARATOR_STROKE = 'rgba(153,153,153,0.5)';

const MOBILE_WIDTH_LIMIT = 641;

export const isMobile = screenWidth => screenWidth < MOBILE_WIDTH_LIMIT;

export const MAX_SIMPLE_CHART_Y_AXIS_VALUE = 100;

export const CoP = {
  PERSON: 'P',
  BUSINESS: 'B',
  PARTIAL_MATCH: 'PMTC',
  MATCH: 'MTCH',
  NO_MATCH: 'NMTC',
  NOT_APPLICABLE: 'NOAP',
  ACCOUNT_TYPE_NO_MATCH: 'ATNM'
}

export const ALERT_CATEGORY = {
  USER: 'USER',
  APP: 'APP'
}

export const AVQ_DOWNTIME = "AVQ_DOWNTIME";

export const AVALOQ_ALERT_ID = 486;

export const TYPOGRAPHY = {
  font: {
    size: {
      header1: 32,
      header2: 24,
      header3: 20,
      header4: 16,
      large: 16,
      huge: 45,
      large32: 32,
      large16: 16,
      large20: 20,
      large18: 18,
      normal: 14,
      small: 12,
      xsmall: 10,
      xxsmall: 8,
    },
    tabletSize: {
      header1: 35,
      header2: 27,
      header3: 25,
      header4: 19,
      large: 19,
      normal: 17,
      small: 15,
      xsmall: 13,
      xxsmall: 11,
    },
  },
};


export const INCOME_EXPENSE = {
  income: '#167F39',
  expense: '#A62103'
};

export const DATE_AVALOQ = {
  dateCH: '31.7.2014',
  dateUK: '19.7.2015',
  dateLux: '31.12.2017',
  defaultDate: '01.01.2014'
};

export const BRANCH_CODE = {
  branchCodeCH: '4',
  branchCodeUK:'35',
  branchCodeLUX: '48'
};

export const DBK_FONT_FAMILY = {
  dbkText: theme.fontFamilyRegular,
  dbkTextDisplay: theme.fontFamilyMedium
}

export const PALETTE = {
  primaryActive: theme.palettePrimaryActive,
  primaryText: '#a7a8aa',
  dawnBlue: '#12213C',
  primaryTextDisabled: '#999',
  primaryStrokeLine: SEPARATOR_STROKE,
  primaryBackground: '#000E28',
  secondaryActive: '#ffffff',
  secondaryText: '#999',
  secondaryTextDisabled: '#333',
  secondaryDisabled: '#eceef0',
  secondaryBackground: '#333',
  lineChartColor: theme.palettePrimaryActive,
  lineChartAxisColor: '#999',
  lineChartGridColor: '#999',
  bottomNavBackground: '#000',
  bottomNavSeparator: '#333',
  bottomNavItem: '#999',
  appBackground: '#000',
  errorColor: '#E3002D',
  successColor: '#7AB800',
  loginFooterText: '#A3A4A7',
  successIcon: '#00C7B1',
  matchColor: '#A5B740',
  partialMatchColor: '#010E28',


  // extras
  primaryNegative: '#FF4433',
  primaryPositive: '#3e82ef',
  sortingHeaderBorder: '#11223c',
  validationPositive: '#6F9D38',
  equity: '#53A8E2',
  fixed: '#16B17E',
  expand: '#ec6b10',
  warning: '#f2a900',
  dbModalBackground: theme.paletteInverseSecondaryBorder,
  primaryInverseText: theme.palettePrimaryInverseDefaultText,
  performanceChart: '#3B86FE',
  currencyChart: '#76DEFB',
  paymentPending: '#F2A900',
  paymentExecuted: '#6F9D38',
  paymentDelRev: '#FF3838',
  darkBlue: '#00205B',
  fordGray: '#979797',
  duskBlue:'#0E1B34',
  morningBlue:'#162746',
  touchableOpacityEnable: '#00A3E0',
  touchableOpacityDisable: '#202B2E',
  primaryRadioButtonBorder: '#535B61',
  paleBlue: '#A4C8E1',
  darkBlue: '#00205B',
  fordGray: '#979797',
  duskBlue:'#0E1B34',
  morningBlue:'#162746',
  cyanBlue:'#283950',
  turquoiseGreen: '#00C7B1',
  midnightBlue: '#000E28',
  darkGrey: '#535B61',
  highlightSearchText: '#00A3E0',
};

export const MARKER_COLOURS = {
  cash: {
    fill: '#DBECF8',
  },
  fxForwards: {
    fill: '#8b9dc3',
  },
  mmInstruments: {
    fill: '#2C82BE',
  },
  bonds: {
    fill: '#76DDFB',
  },
  equities: {
    fill: '#53A8E2',
  },
  optionsDerivatives: {
    fill: '#62737F',
  },
  alternatives: {
    fill: '#2581C2',
  },
  various: {
    fill: '#07578E',
  },
  loans: {
    fill: '#0597FB',
  },
  surplus: {
    fill: '#555859',
  },
  fixedincome: {
    fill: '#DBECF8',
  },
  commodities: {
    fill: '#889096',
  },
  others: {
    fill: '#078E85',
  },
  liquidity: {
    fill: '#76DDFB',
  },
  equity: {
    fill: '#53A8E2',
  },
};


export const SIZES = {
  appHorizontalSpace: 10
};

export const PAGE = {
  pageSize: 50,
  defaultPageNumber: 0,
};
export const ORIENTATIONS = {
  portrait: 'PORTRAIT',
  portraitUpsideDown: 'PORTRAITUPSIDEDOWN',
  landscape: 'LANDSCAPE',
  unknown: 'UNKNOWN',
};

export const CURRENCIESWITHOUTDECIMALS = [
  'JPY',
  'KRW',
  'ISK',
];

export const NUMBER_SCALE = [
  '',
  'app.constant.thousands',
  'app.constant.millions',
  'app.constant.billions',
  'app.constant.trillions',
  'app.constant.quadrillions',
  'app.constant.quintillions',
  'app.constant.sextillions',
  'app.constant.septillions',
  'app.constant.octillions',
  'app.constant.nonillions',
];

export const NO_DATA = '—';
export const NO_DATA_TEXT = 'app.portfolio.dashboard.noChartData';

export const APP_NAMESPACE = 'com.db.awm.uisdk.ebanking:';
export const MQ_TABLET = '@media (min-device-width: 700) and (max-device-width: 1224)';
export const MQ_PHONE = '@media (min-device-width: 320) and (max-device-width: 700)';

export const SM_DEVICE = '@media (min-device-width: 0) and (max-device-width: 321)';
export const VASCO_RASP_ERR_URL = '/vascorasp'


export const MOTION = {
  duration: 330,
  easing: {
    in: (k) => k * k * k * k * k,
    out: (k) => --k * k * k * k * k + 1, // eslint-disable-line no-param-reassign
  },
};
export const VASCO_STATUSES = {
  pending: 'ACT_PENDING',
  error: 'ACT_ERROR',
  complete: 'ACT_COMPLETE',
  pinError: 'ACT_PIN_ERROR',
};

export const VASCO_RETURN_CODES = {
  SUCCESS: "0",
  PASSWORD_LENGTH_TOO_SHORT: -4026,
  PASSWORD_LENGTH_TOO_LONG: -4027,
  PASSWORD_WEAK: -4028,
  PASSWORD_WRONG: -4029,
  PASSWORD_LOCK: 1007,
  DIGIPASS_INVALID: -4031,
};

export const VASCO_API_ERROR_CODES = {
  SUCCESS: 0,
  userLocked: 1007,
  otpIncorrect: 1012,
  staticPwdInCorrect: 1011,
  activationDenied: 1050,
  otpReplay: 1008,
  user2FALocked: 1070,
  user2FADisabled: 1069,
  invalidSession: 1061,
  TWOFA_REGISTRATION_PENDING: 4005
};

export const VASCO_API_RESPONSE = {
  success: 'SUCCESS',
  error: 'error',
};

export const VASCO_MODAL_TYPES = {
  pin2fa: 'MODAL_PIN_2FA',
  notActivated: 'MODAL_VASCO_NOT_ACTIVATED',
  failUserLocked: 'MODAL_FAIL_USER_LOCKED',
  failExceededOtp: 'MODAL_FAIL_2FA_USER_LOCKED_EXCEEDED_OTP',
  ntbUser: 'MODAL_NTB_USER'
};

export const VASCO_FLOW = {
  noVasco: 'VASCO_DISABLED',
  notActivated: 'VASCO_NOT_ACTIVATED',
  browser: 'BROWSER',
  resetPassword: 'VASCO_RESET_PASSWORD',
};

export const VASCO_ERROR_MESSAGES = {
  otpVerificationErrorString: 'Error in OTP verification',
};

export const WEBSSO_API_RESPONSE = {
  success: 'SUCCESS',
  error: 'error',
};

export const WEBSSO_ERROR_TYPES = {
  errorPage: 'WEBSSO_ERROR_PAGE'
};

export const TRANSACTION_API_ERROR_CODES = {
  errorCode: -1
};
export const WEBSSO_ERROR_CODES = {
  SUCCESS: 0,
  unexpectedError: -1,
  notAuthorized: 401,
  noRecordToFetch: 404,
  serviceUnAvailable: 500,
  accountBlocked: 1069,
  multipleUserID: 8888,
  BAD_REQUEST: 400,
  OK: 200
};

export const CHANNEL_TYPES = {
  WEB: 'WEB',
  DEVICE: 'DEVICE',
  BROWSER: 'BROWSER'
};

export const TRANSACTION_TYPE = {
  PAYMENTS: 'PAYMENTS',
  TRADING: 'TRADING'
};

export const TRANSACTION_TITLE = {
  SEPA: 'SEPA',
  SWIFT: 'SWIFT',
  INTERNATIONAL: 'INTERNATIONAL',
  DOMESTIC: 'DOMESTIC'
};
export const PAYMENTS_UI_TIMER = { remainingTimeInSeconds: 240 };

export const DASHBOARD_2FA_REGIONS = ['CH'];

export const MANAGE_CONTACT_DETAILS_CONSTANTS = {
  MANAGE_CONTACT_DETAILS_ACCOUNT_HOLDER: 'Account Owner',
  READ: 'READ',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  CREATE_READ: 'CREATE_READ',
  DELETE_READ: 'DELETE_READ',
  CREATE_DELETE: 'CREATE_DELETE',
  UPDATE_DELETE: 'UPDATE_DELETE',
  CREATE_UPDATE: 'CREATE_UPDATE',
  UPDATE_READ: 'UPDATE_READ',
  FAX: 'fax',
  EMAILID: 'emailId',
  PHONE_NO: 'phoneNo',
  PHONE: 'phone'
}

export const HRMW_CONSTANTS = {
  INVESTMENT: 'INVESTMENT',
  INVESTMENT_TRANSFER: 'INVESTMENT_TRANSFER',
  EMAIL: 'EMAIL',
  FAX: 'FAX',
  PHONE: 'PHONE',
  EMAIL_REGEX: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  FAX_REGEX: /^\d{5,}$/,
  PHONE_NO_REG_EX: /^\d{5,}$/,
  FAX_REG_EX: /^\d{5,}$/
}

export const HRMW_DROPDOWN_CONSTANTS = [
  { label: 'Phone', value: 'FIXED_LINE' },
  { label: 'Mobile Phone', value: 'MOBILE' }
]

export const ROUTES = {
  PORTFOLIO: {
    DASHBOARD: '/portfolios',
    GENERIC_ASSETS: '/portfolios/genericAssets'
  },
  PAYMENT: {
    DASHBOARD: '/payments',
    NEW_DOMESTIC: '/payments/domestic-payment-form',
    DESTINATION: '/payments/destination',
    TX_SUMMARY: '/payments/summary',
    DEBIT_ACCOUNT_LIST: '/payments/debit-account-list',
    FILTER: '/payments/init-payments/payment-filter',
    ADD_BENEFICIARY: '/payments/destination/payment-add-beneficiary',
    LOADING: '/payments/payment-loading',
    TEMPLATE: '/payments/templateList',
    PSD2_AIS: '/psd2/aisflow',
    PSD2_PIS: '/psd2/pisflow'
  },
  TRADE: {
    LIBRARY: '/trade-library',
    OVERVIEW: '/trade/overview',
    NEW_ORDER: '/trade/new-order'
  },
  RMACCESS: {
    LOGIN_PAGE: 'rmAccess',
    DOC_UPLOAD_ROUTE: 'rm-access/doc-upload',
    DOC_LANDING_PAGE: '/rm-access/doc/landing-page',
    DOC_TAB_CONTAINER: '/rm-access/doc-upload/doc-upload-tab-container',
    DOC_SEARCH: '/rm-access/doc-upload/doc-upload-search',
    DOC_FORM: '/rm-access/doc-upload/upload-document-form',
    DOC_CONDITIONS: '/rm-access/doc-upload/doc-upload-conditions',
    DOC_FINALIZE: '/rm-access/doc-upload/docu-upload-finalize',
    DOC_TAB_CONTAINER_FAQ: '/rm-access/doc-upload/doc-upload-tab-container/login-faq',
    DOC_TAB_CONTAINER_SEQURITY: '/rm-access/doc-upload/doc-upload-tab-container/login-security'
  },
  PROFILE: {
    SETTINGS_ROUTE: '/profile',
    USER_BP_LIST_ROUTE: '/profile/user-bp-list',
    MANAGE_CONTACT_DETAILS_ROUTE: '/profile/manage-contact-details',
    ADD_CONTACT_DETAILS_ROUTE: '/profile/add-contact-details',
    USER_HRMW_FORM_ROUTE: '/profile/hrmw-form',
    MANAGE_CONTACT_DETAILS_AMEND_CONTACT: '/profile/amend-contact',
    MANAGE_CONTACT_DETAILS: '/manage-contact-details',
    AMEND_CONTACT: '/amend-contact',
    ADD_CONTACT: '/add-contact-details'
  },
  SUMMARY: {
    DASHBOARD: '/dashboard'
  },
  PAPERLESS: {
    PAPERLESS_SETTINGS_ROUTE: '/profile/paperless-settings'
  },
  CASH_ACCOUNTS: {
    SUMMARY_CASH_ACCOUNTS_ROUTE: '/cashAccounts',
    SUMMARY_CASH_ACCOUNTS_DETAILS_ROUTE: '/cashAccounts/cashAccountsDetails',
    SUMMARY_CASH_ACCOUNTS_MORE_DETAILS: '/cashAccounts/cashAccountsMoreDetails'
  },
  REPORTS: {
    ORDER_REPORT: "/reports/adhoc-statement"
  }
}

export const LOGGEDIN = {
  YES: "Yes",
  NO: "No",
}


// export const TIMER = {
//   PAYMENT_PENDING_TX: 240000, // ms
//   PAYMENT_PENDING_TX_MMSS: '04:00',
//   // * debug
//   // PAYMENT_PENDING_TX: 4000, // ms
//   // PAYMENT_PENDING_TX_MMSS: '00:04',
// }

export const REMOTE_URL = {
  ANDROID: "https://play.google.com/store/apps/details?id=",
  IOS: "https://itunes.apple.com/us/app/deutsche-wealth-online/id"
}

export const ERGON_API_ERROR_CODES = {
  invalidCredentials: 1003,
  user1FAlocked: 1070,
  wrongExistingPassword: 1052,
  passwordAlreadyUsed: 1051,
  passwordExpired: 1019,
  accTempLock: 1072
};

export const EDELIVERY = {
  UNREAD_CATEGORY_ID: 4002,
};

export const DOCSIGN_API_ERROR_CODES = {
  SUCCESS: 0,
  SUCCESS_INT: '0',
  EMPTY_DOCUMENT_LIST: '704',
  EMPTY_DOCUMENT_LIST_INT: 704,
  NO_DOCSIGN_DATA_INT: 704,
  NO_DOCSIGN_DATA: '704',
  DOCUMENT_UPLOAD_FAILED: '701',
  DOCUMENT_UPLOAD_FAILED_INT: 701,
  DMS_UPLOAD_FAILED: '700',
  DMS_UPLOAD_FAILED_INT: 700,
  BASE64_CONVERSION_FAILED: '702',
  BASE64_UPLOAD_FAILED_INT: 702,
  TABLE_UPDATE_FAILED: "5001",
  TABLE_UPDATE_FAILED_INT: 5001,
  NOT_PENDING_AND_PULLBACK: "802",
  NOT_PENDING_AND_PULLBACK_INT: 802,
  REJECT_COMMENT_REQ_INT: 804,
  REJECT_COMMENT_REQ: '804',
  DMS_UPLOAD_ERROR_INT: 5001,
  DMS_UPLOAD_ERROR: '5001',
  DOCUSIGN_API_ERROR_INT: 800,
  DOCUSIGN_API_ERROR: 800,
  PDF_MISSING_ANCHOR_TAG: '703',
  PDF_MISSING_ANCHOR_TAG_INT: 703,
  INTERNAL_SERVER_ERROR: '500',
  INTERNAL_SERVER_ERROR_INT: 500
}

export const DOCUPLOAD_FILE_RULES = {
  maxSize: 5242880,
  extension: 'pdf'
}
export const TIMELIST = [
  { label: '12:00 AM', value: '00:00:00' },
  { label: '12:30 AM', value: '00:30:00' },
  { label: '01:00 AM', value: '01:00:00' },
  { label: '01:30 AM', value: '01:30:00' },
  { label: '02:00 AM', value: '02:00:00' },
  { label: '02:30 AM', value: '02:30:00' },
  { label: '03:00 AM', value: '03:00:00' },
  { label: '03:30 AM', value: '03:30:00' },
  { label: '04:00 AM', value: '04:00:00' },
  { label: '04:30 AM', value: '04:30:00' },
  { label: '05:00 AM', value: '05:00:00' },
  { label: '05:30 AM', value: '05:30:00' },
  { label: '06:00 AM', value: '06:00:00' },
  { label: '06:30 AM', value: '06:30:00' },
  { label: '07:00 AM', value: '07:00:00' },
  { label: '07:30 AM', value: '07:30:00' },
  { label: '08:00 AM', value: '08:00:00' },
  { label: '08:30 AM', value: '08:30:00' },
  { label: '09:00 AM', value: '09:00:00' },
  { label: '09:30 AM', value: '09:30:00' },
  { label: '10:00 AM', value: '10:00:00' },
  { label: '10:30 AM', value: '10:30:00' },
  { label: '11:00 AM', value: '11:00:00' },
  { label: '11:30 AM', value: '11:30:00' },
  { label: '12:00 PM', value: '12:00:00' },
  { label: '12:30 PM', value: '12:30:00' },
  { label: '01:00 PM', value: '13:00:00' },
  { label: '01:30 PM', value: '13:30:00' },
  { label: '02:00 PM', value: '14:00:00' },
  { label: '02:30 PM', value: '14:30:00' },
  { label: '03:00 PM', value: '15:00:00' },
  { label: '03:30 PM', value: '15:30:00' },
  { label: '04:00 PM', value: '16:00:00' },
  { label: '04:30 PM', value: '16:30:00' },
  { label: '05:00 PM', value: '17:00:00' },
  { label: '05:30 PM', value: '17:30:00' },
  { label: '06:00 PM', value: '18:00:00' },
  { label: '06:30 PM', value: '18:30:00' },
  { label: '07:00 PM', value: '19:00:00' },
  { label: '07:30 PM', value: '19:30:00' },
  { label: '08:00 PM', value: '20:00:00' },
  { label: '08:30 PM', value: '20:30:00' },
  { label: '09:00 PM', value: '21:00:00' },
  { label: '09:30 PM', value: '21:30:00' },
  { label: '10:00 PM', value: '22:00:00' },
  { label: '10:30 PM', value: '22:30:00' },
  { label: '11:00 PM', value: '23:00:00' },
  { label: '11:30 PM', value: '23:30:00' },
];

export const DOC_STATUS_MAPPING = [
  { status: 'SIGN_VERIFIED', colorClass: 'doc-status-success', displayValue: 'Bank Verified' },
  { status: 'VERIFICATION_PENDING', colorClass: 'doc-status-neutral', displayValue: 'Pending Verification' },
  { status: 'PULLED_BACK', colorClass: 'doc-status-neutral', displayValue: 'Pulled Back' },
  { status: 'ENVELOPE_SENT', colorClass: 'doc-status-neutral', displayValue: 'Pending' },
  { status: 'CLIENT_REJECTED', colorClass: 'doc-status-error', displayValue: 'Client Rejected' },
  { status: 'SIGN_REJECTED', colorClass: 'doc-status-error', displayValue: 'Bank Rejected' },
  { status: 'EXPIRED', colorClass: 'doc-status-neutral', displayValue: 'Expired' },
];

export const DOC_STATUS_VALIDATIONS = {
  showAcceptVerify: ['VERIFICATION_PENDING'],
  downloadStampedDoc: ['VERIFICATION_PENDING', 'SIGN_VERIFIED', 'SIGN_REJECTED'],
  showPullBack: ['ENVELOPE_SENT'],
  hideTargetDateTime: ['EXPIRED', 'PULLED_BACK', 'CLIENT_REJECTED', 'ENVELOPE_SENT']
}

export const DOC_MANAGE_ACTIONS = {
  verify: 'verify',
  reject: 'reject',
  pullback: 'recall'
};

export const DATE_FORMATS = {
  displayDate: 'DD MMM YYYY',
  displayDateAndTime: 'DD MMM YYYY HH:mm',
  date: 'YYYY-MM-DD',
  dateAndTime: 'YYYY-MM-DD HH:mm',
  displayChatDateAndTime: 'DD MMM YYYY, hh:mm a',
  datepickerDateFormat: 'dd MMM yyyy',
}

// export const DOC_STATUS_COLORS = [
//   {status: 'VERIFIED',            color: '#4CBA38'},
//   {status: 'ACCEPTED',            color: '#5CB7AC'},
//   {status: 'PULLED BACK',         color: '#A4C8E1'},
//   {status: 'CLIENT PENDING',      color: '#F8E71C'},
//   {status: 'ACCEPTANCE REJECTED', color: '#5F9BC6'},
//   {status: 'REJECTED',            color: '#C93B32'},
//   {status: 'EXPIRED',             color: '#A7A8AA'},
// ];

export const DOCSIGN_CONSTANTS = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  CANCEL: 'cancel',
  SUCCESS_RESPONSE: 'success',
  REJECT_RESPONSE: 'rejected',
  PENDING_ACTION: 'PENDING_ACTION',
  OTHERS: 'OTHERS',
  DOCUSIGN_SIGNING_COMPLETE: 'signing_complete',
  DOCUSIGN_DECLINE: 'decline',
  DOCUSIGN_ACCESS_CODE_FAILED: 'access_code_failed',
  DOCUSIGN_CANCEL: 'cancel',
  DOCUSIGN_TTL_EXPIRED: 'ttl_expired',
}

export const DOCSIGN_STATUS = {
  BANK_VERIFIED: 'Bank Verified',
  PENDING: 'Pending',
  EXPIRED: 'Expired',
  PULLED_BACK: 'Pulled Back',
  PENDING_VERIFICATION: 'Pending Verification',
  CLIENT_REJECTED: 'Client Rejected',
  BANK_REJECTED: 'Bank Rejected',
}

export const NOTIFICATION_TYPE = {
  esignature: 'esignature',
  investment: 'dbXpert Top Picks'
}

export const AUTHORIZATION_ERROR_CODES = {
  invalidPassword: 1050,
}

export const MENU_OPTIONS = {
  RM_CALLBACK: 'rmcallback',
  SETTINGS: 'settings',
  PAYMENTS: 'payments',
  DOCSIGN_CENTER: 'docsigncenter',
  DOCSIGN: 'docsign',
  CHAT: 'chat',
  INVESTMENT: 'dbXpert Top Picks',
  TRADE: 'trade'
}

export const CHAT_MSG_TYPE = {
  HANDSHAKE: 'HANDSHAKE',
  CHAT_MSG: 'CHAT_MSG',
  HEARTBEAT: 'HEARTBEAT'
};

export const CHAT_RECIPIENT_TYPE = {
  GROUP: 'GROUP',
  INDIVIDUAL: 'INDIVIDUAL'
};

export const CHAT_ATTACHMENT_INDICATOR = {
  YES: 'Y',
  NO: 'N'
};

export const CHAT_CHRONO_UNIT = {
  DAYS: 'DAYS',
  HOURS: 'HOURS',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
};


export const QUANTITY = 'Quantity';
export const STüCKZAHL = 'Stückzahl';

export const FILTER_MODAL_FIELD_NAME = {
  DOCUMENT_NAME: 'documentName',
  ORDER_ID: 'orderId',
  RM_NAME: 'rmName',
  CLIENT_NAME: 'clientName',
  SIGNED_DATE: 'signedDate',
  UPLOAD_DATE: 'uploadDate',
  DUE_DATE: 'dueDate',
  DOCUMENT_TYPE: 'documentType',
  PORTFOLIO_ID: 'pfId',
  RM_TEAM: 'rmTeam',
  TEMPLATE_SID: 'templateSid',
  TEMPLATE_NAME: 'templateName',
  RM_NAME_RESPONSE: 'rmNameResponse',
  CLIENT_NAME_RESPONSE: 'clientNameResponse',
  ORDER_ID_RESPONSE: 'orderIdResponse',
  DOCUMENT_NAME_RESPONSE: 'documentNameResponse',
  DOCUMENT_STATUS: 'docStatus',
  FROM: 'from',
  TO: 'to'
};
export const DOCSIGN_API_SETTIMEOUT_CODES = {
  DELAY: 300000
}

export const INVESTMENT_API_CODES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  SUCCESS_INT: 0
}

export const INVESTMENT_CONSTANTS = {
  READ: 'READ',
  BUY: 'Buy',
  SELL: 'Sell'
}
export const CHANNEL = {
  WEB: 'WEB'
}

export const API_RESPONSE_CODES = {
  SUCCESS: '0',
  ERROR: '1',
  INVALID_USERNAME_AND_EMAILID: '700',
  VASCO_ELIGIBILITY_CHECK: '706',
  ERGON_API_INITIATE_FAILURE: '708',
  NO_AUTHCODE_FOUND: '1013',
  EXPIRED_AUTHCODE: '1014',
  INCORRECT_AUTHCODE: '1015',
  ERROR_MAX_COUNT: '1016',
  ERROR_IN_EMAIL_SERVICE: '1017',
  ERGON_TEMP_PWD_NOT_GENERATE: '1018',
  EXPIRED_PASSWORD: '1019',
  ERROR_CODE: '-1'
}

export const RM_ACCESS_ERROR_CODE = {
  SESSION_ERROR: 1002,
  NO_ACCESS: 1003,
  JWT_GENERATION_ERROR: '1004'
}
export const ENTITLEMENT = {
  tradingModule: 'p4',
  dataExtracts: 'p2',
  transactions: 'p1'
}

export const TRADE_ASSET_ICON_STYLE = {
  width: 34,
  height: 34,
  color: '#ffffff',
};

export const TRADE_COLORS = {
  EQUITY: "#5C9AC8",
  GRAPH_POPOVER: "#000D28",
  CHART: "#A4CDE1"
}

export const DEVICE_CODE = 'BROWSER';

export const RESPONSE_TYPE = {
  FAILED: "Grace Period Expired"
}
export const LANGUAGE_KEY = {
  SELECTED_LANGUAGE: "SelectedLanguage",
  SELECTED_LANG_CODE: "SelectedLanguageCode",
  SELECTED_REGION: "SelectedRegion"
}

export const SEPERATOR = '#@#';

export const TOAST_MESSAGE_TYPE = {
  ERROR: "error",
  INFO: "information",
  CONFIRMATION: "confirmation"
}

export const APIRESPONSECODES = {
  success: 0,
  error: -1,
};

export const REGION = {
  CH: 'CH',
  APAC: 'APAC'
};


export const LANGUAGES = {
  ENGLISH: "English",
  DEFAULT: "default",
  DEUTSCH: "Deutsch"
};

export const LANGUAGE_SHORT_CODE = {
  EN: "EN",
  DE: "DE",
  ZH: "ZH"
};

export const ECREDENTIALS = {
  EPWD_RESET_STATUS: 'E-PASSWORD-RESET',
  EPWD_RESET_EXPIRED: 'E-PASSWORD-RESET-EXPIRED',
  EPWD_RESET_COMPLETED: 'E-PASSWORD-RESET-COMPLETED',
  EPWD_RESET_MAX_ATTEMPT: 'E-PASSWORD-RESET-MAX-ATTEMPT',
  EPWD_RESET_INITIATED: 'E-PASSWORD-RESET-INITIATED'
};

export const RM_ACCESS = {
  RM_READ_ONLY: 'RM_READ_ONLY',
  RM_DOC_UPLOAD: 'RM_DOC_UPLOAD',
  LOGIN_ONBEHALF: 'LOGIN_ONBEHALF',
  SEARCH_SUCCESS: "0",
  SEARCH_ERROR: "-1",
  RM_USER_GROUP: 95,
  SESSION_ACTIVE: "1",
  NO_ACCESS_BP: 1003,
  NO_ACCESS_CONTRACT_ID: 1004,
};

export const DATA_EXPORT_TYPE = {
  CSV_FOR_TRANSACTIONS: "CSV_FOR_TRANSACTIONS",
  XLX_FOR_TRANSACTIONS: "XLX_FOR_TRANSACTIONS",
  CSV_FOR_POSITIONS: "CSV_FOR_POSITIONS",
  XLX_FOR_POSITIONS: "XLX_FOR_POSITIONS",
  TRANSACTIONS: "Transaction",
  POSITIONS: "Positions",
  EXPORT_SIZE: "0",
  EXPORT_SIZE_INVALID: "1",
  CSV: "csv",
  XLS: "xls"
};

export const ALL_PORTFOLIO_ID = "00000000.00";

export const ALL_REPORT_PORTFOLIO = {
  "id": "00000000.00",
  "title": "All Portfolios",
  "referenceCurrency": "",
  "relId": null,
  "branchCode": 4,
  "isPaymentAvailable": true
};
export const DOC_UPLOAD = {
  NA: "NA",
  DOC_TYPE: "application/pdf",
  ORDER_ASC: "asc",
  ORDER_DESC: "desc",
  MAXSIZE: 10485760,
  USERID_PREFIX: "DB",
  PAGE_NUMBER: 0,
  RECORD_SIZE: 10,
  STATUS_FAILED: "FAILED",
  TEXTAREA_MAXLENGTH: 1000,
  NON_DWO_USER: "Non DWO user",
  NO_DWO_ACCESS: "No DWO Access",
  STATUS: {
    ACTIVE: "Active",
    INACTIVE: "In Active",
  },
  STATUS_META_DATA: {
    'Failed': 'statusFailed',
    'In Progress': 'statusInprogress',
    'Uploaded': 'statusUploaded'
  },
  DEFAULT_DATE: '2018',
  UPLOAD_CHUNK_SIZE: 2000000,
};

export const UPLOADHISTORY_FILTER_NAME = {
  BPID: "bpId",
  EBANKING_CONTRACT: "contract",
  CONTRACT_NAME: "userName",
  DOCUMENT_NAME: "dwoDocName",
  UPLOAD_DATE: "createdTs",
  STATUS: "status"

}

export const RM_LOGIN = 'RM_LOGIN';
export const EBANKINGWEBLUX = 'ebankingweblux';
export const EBANKINGWEBUK = 'ebankingwebuk';
export const EBANKINGWEB = 'ebankingweb';
export const RM_REGION_CH = 'rmch';
export const RM_REGION = 'rmlux'
export const RM_REGION_UK = 'rmuk';
export const DOT_UNICODE = '\u2022';

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  EXECUTED: 'EXECUTED',
  DELETED: 'DELETED',
  REVERSED: 'REVERSED',
  REJECTED: 'REJECTED'
}
export const MULTISIGN_PAYMENT_STATUS = {
  DRAFT: 'DRAFT',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PARTIALLY_APPROVED: 'PARTIALLY_APPROVED',
  APPROVED: 'APPROVED',
  EXPIRED: 'EXPIRED',
  REJECTED: 'REJECTED',
  EXECUTED: 'EXECUTED',
  APPROVAL_IN_PROGRESS:'APPROVAL_IN_PROGRESS',
  ABORTED: 'ABORTED',
  DISCARDED: 'DISCARDED',
  RULES_CHANGED: 'RULES_CHANGED',
}
export const MULTISIGN_TAB_SELECT = {
 SUBMITTED_PAYMENTS: 0,
 MULTISIG_APPROVALS: 1,
}


export const PORTFOLIO_RELIDTYPE = {
  ALL_PORTFOLIOS: "4003",
  BP: "4002",
  PORTFOLIOS: "1002",
  CONSOLIDATED: "4001"

}
export const PDF_NAME = {
  ONLINE_TERMS_ENGLISH: "E-Banking_terms_english_June23.pdf",
  ONLINE_TERMS_GERMAN: "E-Banking_terms_german_June23.pdf",
  NEW_EBANKING_ENGLISH: "new_e-banking_client_english.pdf",
  NEW_EBANKING_GERMAN: "new_e-banking_client_german.pdf",
  OLD_USER_ENGLISH: "Migrate_user_english.pdf",
  OLD_USER_GERMAN: "Migrate_user_german.pdf",
  TERMS_CONDITION_ENGLISH: "static/Online_Terms/LUX/English/E-Banking_terms_english_June23.pdf",
  TERMS_CONDITION_GERMAN: "static/Online_Terms/LUX/SwissGerman/E-Banking_terms_german_June23.pdf",
  ACCESSIBILITY_FILE_ENG_NAME: "E-Banking_accessibility_info_english.pdf",
  ACCESSIBILITY_FILE_DEU_NAME: "E-Banking_accessibility_info_german.pdf",
}

export const CANADIAN_COUNTRY = {
  english: 'canada',
  german: 'kanada',
  currencyCode: 'CAD'
}

export const PORTFOLIO_BP_LIMIT = 300;
export const PAYMENTS_RETURN_CODES = {
  TEMPLATE_EXIST: '709'
}

export const WARNING_ICON = {
  width: 25,
  height: 25
}

export const ASSET_TRADE_TYPE = {
  trade_type: '27002',
}

export const PAPERLESS_OPT_IN_STATUS = {
  YES: 'YES',
  NO: 'NO',
  PENDING: 'PENDING',
  EALERT_YES: 'Y',
  EALERT_NO: 'N'
}

export const ACCOUNT_TYPE = {
  OWNERNAME: 'ownername',
  TRANSACTION: 'transactions',
  BALANCES: 'balances',
  ACCOUNTS: 'accounts'
}

export const SHIELD_ERROR_CODES = {
  ZERO: '0',
  ONE: '1',
  TWO: '2',
  THREE: '3',
  FOUR: '4',
  FIVE: '5',
  SIX: '6',
  SEVEN: '7',
  EIGHT: '8',
  NINE: '9',
  TEN: '10',
  ELEVEN: '11',
  TWELVE: '12',
  THIRTEEN: '13',
  FOURTEEN: '14',
  FIFTEEN: '15',
  SIXTEEN: '16',
  SEVENTEEN: '17',
  TWENTYSIX: '26',
  TWENTYSEVEN: '27',
  TWENTYEIGHT: '28'

}

export const CASH_ACCOUNTS_CONSTANTS = {
  CASH_ACCOUNTS: 'cashAccounts',
  NAME: 'name',
  IBAN: 'iban',
  ACCOUNT:'accountName',
  PF_ID: 'pfId',
  PF_TYPE: 'pfType',
  BALANCE: 'balance',
  MKT_VAL: 'mktVal',
  ARROW: 'arrow',
  NEW_PAYMENT:'newpayment',
  CASH_ACCOUNT_DETAILS: 'cashAccountDetails',
  CASH_ACCOUNT_CURRENCY: 'cashAccCurrency'
}
export const LOGOUT_DSC = "Logged out from WEB";
export const OTP_INTERVAL = 32;
export const FSCS_LOGO_URL = "https://www.deutschewealth.com/en/uk/financial-services-compensation-scheme.html";
export const ALL_CHARGES_EN = "All charges to you";
export const ALL_CHARGES_DE = "Alle Kosten zu Lasten des Auftraggebers";
export const ERROR_CODE_WSO2 = 'Response code 400';

export const FORGOT_PASSWORD_FLOW_STEPS = ['forgot_password', 'otp', 'create_new_password', 'success']; 
export const REPORTS = {
  VARIABLE_TAB_INDEX: 3,
  NUMBAR_OF_FIXED_TABS: 4
}
export const LINKS_NAME = {
  FIRST_TIME_LOGIN: "first-time-login",
  REGISTER_NEW_DEVICE: "register-new-device",
  MOBILE_APP_GUIDE: "mobile-app-guide",
  FORGOT_PASSWORD: "forgot-password",
  USERNAME: "username"
}
export const KEY_CODE = {
  ENTER_KEY: 13,
  SPACE_KEY: 32
}

export const ERGON_CHANGE_PASSWORD_TYPE = {
  MANDATORY_CHANGE_PASSWORD: 'MANDATORY_CHANGE_PASSWORD',
  VOLUNTARY_CHANGE_PASSWORD: 'VOLUNTARY_CHANGE_PASSWORD'
}
export const OTHERS_INC_LOANS="Others (inc. Loans)"
export const NO_OF_MATURITIES="No. of Maturities"

export const DOWNTIME_TYPE = {
    ACTIVE: "ACTIVE_DOWNTIME",
    PLANNED: "PLANNED_DOWNTIME"
}

export const PAYMENT_DATE_TYPE = {
  EXECUTION_DATE: 'EXECUTION_DATE',
  CONCLUSION_DATE: 'CONCLUSION_DATE'
}

export const EVENT_TYPE = {
  CLICK: "click"
}

export const PENDING_YOUR_APPROVAL = {
  KEY: 'PENDING_YOUR_APPROVAL', 
  LABEL: 'Pending your approval'
}
export const FILTER_MULTISIG_PENDING_NOTIFICATION = ["selectedDate", "paymentStatusList"]

export const FILTER_MULTISIG_NOTIFICATION = ["selectedDate", "date", "paymentStatusList", "initiatorList"];
export const LOCALE_TYPE = {
  EN_US: "en-US",
  EN_GB: "en-GB",
  DE_DE: "de-DE",
  DE_CH: "de-CH"
}

export const DOWNTIME_STRINGS = {
  START_DATE_TIME: "{startDateTime}",
  END_DATE_TIME: "{endDateTime}",
  END_DATE: "{endDate}",
  END_TIME: "{endTime}",
  TIMEZONE: "{timeZone}"
}
